export const JACKET_DISPLAY_OPTIONS = {
  measurements: true,
  points: true,
  seamWalk: false,
  sleeveOnBody: true,
};
